import { faSave, faSearch, faUndo } from "@fortawesome/free-solid-svg-icons";
import classNames from "classnames";
import React, { useEffect, useState, useContext } from "react";
import { useForm } from "react-hook-form";
import NumberFormat from "react-number-format";
import { useSelector } from "react-redux";
import { useParams, useLocation, useHistory } from "react-router-dom";
import { Link } from "react-router-dom/cjs/react-router-dom.min";
import {
  Button,
  Card,
  CardBody,
  CardFooter,
  CardHeader,
  Col,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
  Row,
  Spinner,
  Table,
} from "reactstrap";
import WizardError from "../auth/register/WizardError";
import ButtonIcon from "../common/ButtonIcon";
import Flex from "../common/Flex";
import Loader from "../common/Loader";
import PageHeader from "../common/PageHeader";
import { If, PreloadState } from "../UI/preloading/PreloadState";
import SupportLink from "../root/support/components/SupportLink";
import useSWRFetchPagination from "../../helpers/hooks/useSWRFetchPagination";
import { fetchPublicBanks } from "../../helpers/api/banks";
import FullPagination from "../common/pagination/FullPagination";
import { Toast } from "../UI/toast/Toast";
import { createManagerPayment } from "../../helpers/api/finance";
import FileUploadArea from "../common/FileUploadArea";
import { VE_PHONE_FORMAT } from "../../helpers/utils";
import { SUCCESS_RESPONSE } from "../../helpers/codeResponses/codes";
import moment from "moment";
import { CurrencyContext } from "../../context/Context";
import useModuleBase from "../../helpers/hooks/useModuleBase";
const ManagerServicePayment = () => {
  const moduleBase = useModuleBase();
  const { selectedCondominium } = useSelector((state) => state.condominium);
  const history = useHistory();
  const { baseCurrency } = useContext(CurrencyContext);

  const {
    state: { amount, paid, service, date },
  } = useLocation();

  const { condominiumId, charge } = useParams();
  // eslint-disable-next-line
  const [params, setParams] = useState({
    condominiumId: selectedCondominium,
    search: null,
  });
  const [search, setSearch] = useState("");
  // eslint-disable-next-line
  const [bank, setBank] = useState(null);
  const [selectedBankId, setSelectedBankId] = useState(null);
  const [imagePreview, setImagePreview] = useState(null);
  const [file, setFile] = useState(null);
  const [collapseOne, collapseOneOpen] = useState(false);
  const [submitting, setSubmitting] = useState(false);

  const {
    data,
    handler: { goToPage, nextPage, perPage, previousPage },
    isLoading,
    meta,
  } = useSWRFetchPagination(fetchPublicBanks, params);

  const {
    register,
    handleSubmit,
    formState: { isSubmitting, errors },
    setValue,
    setError,
    clearErrors,
    watch,
  } = useForm({
    mode: "onChange",
  });

  register("voucher");

  const handleImageChange = (event) => {
    if (event.target.files.length !== 0) {
      setImagePreview(URL.createObjectURL(event.target.files[0]));
      setValue("voucher", event.target.files[0]);
      setFile(event.target.files[0]);
    }
  };

  const save = async (values) => {
    setSubmitting(true);
    let form = new FormData();
    form.append("bank_id", selectedBankId);
    form.append("amount", values.amount);
    if (file) form.append("voucher", file);

    createManagerPayment(charge, form)
      .then(({ code }) => {
        if (code === SUCCESS_RESPONSE.OK) {
          collapseOneOpen(false);
          Toast.fire({
            type: "success",
            title: "Pago registrado con éxito",
          });
          history.push(`/dashboard/${moduleBase}/${condominiumId}/my/service`);
        }
      })
      .catch((err) => {
        Toast.fire({
          type: "error",
          title: "Ha ocurrido un error al intentar registrar el pago",
        });
      })
      .finally(() => setSubmitting(false));
  };

  useEffect(() => {
    if (amount) {
      setValue("amount", amount);
    }
    if (!amount || !service || !date) {
      Toast.fire({
        type: "error",
        title: "Ha ocurrido un error al cargar los datos",
      });
      history.push(`/dashboard/${moduleBase}/${condominiumId}/my/service`);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [amount, paid, service, date]);

  const renderBanksItems = () => {
    return data?.map(
      (
        {
          bank_id,
          name,
          owner_name,
          owner_dni,
          email,
          phoneNumber,
          method = "bank",
          account_number,
        },
        index
      ) => (
        <tr
          key={bank_id}
          onClick={() => {
            setSelectedBankId(bank_id);
            setBank(data?.find((item, i) => item.bank_id === bank_id));
          }}
          className={classNames("cursor-pointer", {
            "bg-secondary": selectedBankId === bank_id,
            "text-white": selectedBankId === bank_id,
          })}
        >
          <td className="align-middle" style={{ width: "15%" }}>
            <b>
              {method === "bank"
                ? "Transferencia bancaria"
                : method === "mobile"
                ? "Pago móvil"
                : method === "zelle" && "Zelle"}
            </b>
          </td>
          <td className="align-middle text-center" style={{ width: "40%" }}>
            <If cond={method}>
              <Flex value={"bank"} column align="center" justify="center">
                <p className="mb-0">{name}</p>
                <p className="mb-0">
                  <b>
                    <NumberFormat
                      displayType="text"
                      format="#### #### #### #### ####"
                      value={account_number}
                    />
                  </b>
                </p>
              </Flex>
              <Flex value={"mobile"} column align="center" justify="center">
                <p className="mb-0">{name}</p>
                <p className="mb-0">
                  <b>
                    <NumberFormat
                      displayType="text"
                      format={VE_PHONE_FORMAT}
                      value={phoneNumber}
                    />
                  </b>
                </p>
              </Flex>
              <Flex value={"zelle"} column align="center" justify="center">
                <p className="mb-0">{name}</p>
                <p className="mb-0">
                  <b>{email}</b>
                </p>
              </Flex>
            </If>
          </td>
          <td className="align-middle text-center">
            <p className="mb-0">{owner_name}</p>
            {(method === "mobile" || method === "bank") && (
              <p className="mb-0">
                <b>
                  <NumberFormat
                    prefix={owner_dni.charAt(0)}
                    thousandSeparator
                    value={parseFloat(owner_dni.substring(1, 40))}
                    displayType="text"
                  />
                </b>
              </p>
            )}
          </td>
        </tr>
      )
    );
  };

  useEffect(() => {
    if (selectedBankId) {
      setValue("bank_id", selectedBankId);
      clearErrors("bank_id");
    } else {
      setError("bank_id", {
        message: "El banco es requerido",
      });
      setValue("bank_id", null);
    }
    // eslint-disable-next-line
  }, [selectedBankId]);

  const renderForm = () => (
    <>
      <Row>
        {data ? (
          <>
            <Col>
              <Card>
                <CardHeader>
                  <Row>
                    <Col>
                      <h5 className="mb-2 mb-md-0">Detalle de pago</h5>
                    </Col>
                  </Row>
                </CardHeader>
                <CardBody className="bg-light">
                  <Row form>
                    <Col>
                      <Row>
                        <Col tag={FormGroup}>
                          <Label>Seleccione un metodo de pago de Homelan</Label>
                          <Row>
                            <Col tag={FormGroup} xs={9} className="pr-0">
                              <Input
                                type="text"
                                placeholder="Ingrese el nombre de un metodo de pago"
                                onChange={(event) =>
                                  setSearch(event.target.value)
                                }
                              />
                            </Col>
                            <Col tag={FormGroup} xs={3}>
                              <ButtonIcon
                                className="btn-block"
                                style={{ whiteSpace: "nowrap" }}
                                icon={faSearch}
                                color="falcon-default"
                                onClick={() =>
                                  setParams((prev) => {
                                    return { ...prev, search: search };
                                  })
                                }
                              >
                                Buscar
                              </ButtonIcon>
                            </Col>
                          </Row>
                          <Row>
                            <Col>
                              {!isLoading ? (
                                <Table
                                  responsive
                                  className="mb-0 bg-white fs--1"
                                >
                                  <thead>
                                    <tr>
                                      <th
                                        className="align-middle"
                                        style={{ width: "15%" }}
                                      >
                                        Método de pago
                                      </th>
                                      <th
                                        className="align-middle text-center"
                                        style={{ width: "40%" }}
                                      >
                                        Banco
                                      </th>
                                      <th className="align-middle text-center">
                                        Titular
                                      </th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    {data.length >= 1 ? (
                                      renderBanksItems()
                                    ) : (
                                      <p>No se han encontrado bancos.</p>
                                    )}
                                    <tr>
                                      <td colSpan={3}>
                                        <FullPagination
                                          nextPage={nextPage}
                                          prevPage={previousPage}
                                          goToPage={goToPage}
                                          meta={meta}
                                          className={"shadow-none"}
                                          posText={"bancos"}
                                          perPage={perPage}
                                        />
                                        <WizardError
                                          error={errors["bank_id"]?.message}
                                          className="fs--1 font-weight-normal d-block"
                                        />
                                      </td>
                                    </tr>
                                  </tbody>
                                </Table>
                              ) : (
                                <Loader />
                              )}
                            </Col>
                          </Row>
                        </Col>
                      </Row>
                      <Row>
                        <Col tag={FormGroup}>
                          <FileUploadArea
                            onChange={handleImageChange}
                            preview={imagePreview}
                            fileName={file?.name}
                            onRemove={() => { setFile(null); setImagePreview(null); }}
                            error={errors.voucher?.message}
                          />
                        </Col>
                      </Row>
                      <Row>
                        <Col tag={FormGroup}>
                          <Label>Código de referencia</Label>
                          <Input
                            type="text"
                            name="reference"
                            innerRef={register({
                              required: "El código de referencia es requerido.",
                            })}
                          />
                          {errors["reference"] && (
                            <WizardError
                              error={errors["reference"].message}
                              className="fs--1 font-weight-normal d-block my-2"
                            />
                          )}
                        </Col>
                      </Row>
                    </Col>
                  </Row>
                  <Row className="justify-content-end">
                    <Col xs="auto">
                      <Flex align="end" justify="center" column>
                        <Label className="mb-0">Servicio:</Label>
                        <p className="fs--1">
                          <b>{service}</b>
                        </p>
                        <Label className="mb-0">Fecha de creación:</Label>
                        <p className="fs--1">
                          <b>{moment(date).format("DD/MM/YYYY")}</b>
                        </p>
                        <Label className="mb-0">Total:</Label>
                        <p className="fs--1 mb-0">
                          <b>
                            <NumberFormat
                              prefix={`${baseCurrency.symbol} `}
                              thousandSeparator
                              decimalScale={2}
                              fixedDecimalScale
                              displayType="text"
                              value={amount}
                            />
                          </b>
                        </p>
                        <Label className="mb-0">Pagado:</Label>
                        <p className="fs--1 mb-0">
                          <b>
                            <NumberFormat
                              prefix={`${baseCurrency.symbol} `}
                              thousandSeparator
                              decimalScale={2}
                              fixedDecimalScale
                              displayType="text"
                              value={paid}
                            />
                          </b>
                        </p>
                        <Row className="align-self-stretch border-top my-2" />
                        <Label className="mb-0">Monto a pagar:</Label>
                        <h5 className="mb-0">
                          <b>
                            <NumberFormat
                              max={amount}
                              value={amount}
                              {...register("amount", {
                                required: "Este campo es requerido",
                              })}
                              placeholder="Ingrese un monto"
                              thousandSeparator
                              decimalScale={2}
                              fixedDecimalScale
                              className="border-0 text-right form-control font-weight-bold fs-1 pr-0 bg-transparent"
                              prefix={`${baseCurrency.symbol} `}
                            />
                          </b>
                        </h5>
                      </Flex>
                    </Col>
                  </Row>
                </CardBody>
                <CardFooter>
                  <Row>
                    <Col>
                      <Flex align="center" justify="end">
                        <ButtonIcon
                          tag={Link}
                          to={`/dashboard/${moduleBase}/${condominiumId}/my/service`}
                          icon={faUndo}
                          className="mr-3 px-5"
                          color="falcon-default"
                          size="md"
                          transform="down-1 shrink-4"
                        >
                          <span>Volver</span>
                        </ButtonIcon>
                        <ButtonIcon
                          icon={!submitting ? faSave : null}
                          type="submit"
                          disabled={
                            submitting || Object.keys(errors).length > 0
                          }
                          className="px-5"
                          color="primary"
                          size="md"
                          transform="down-1 shrink-4"
                          data-testid="submit-button"
                        >
                          {submitting && <Spinner size="sm" className="mr-2" />}
                          <span>Registrar pago</span>
                        </ButtonIcon>
                      </Flex>
                    </Col>
                  </Row>
                </CardFooter>
              </Card>
            </Col>
          </>
        ) : (
          <Card className="col-12">
            <Loader padding="py-5" />
          </Card>
        )}
      </Row>
      <Modal isOpen={collapseOne} data-testid="modal">
        <ModalHeader>Confirmación</ModalHeader>
        <ModalBody>
          <p className="mb-0 font-weight-bold fs--1">
            ¿Está seguro de que ingresó todos los datos correctamente? Esta
            información no puede ser cambiada posteriormente.
          </p>
        </ModalBody>
        <ModalFooter>
          <Button disabled={submitting} onClick={() => collapseOneOpen(!collapseOne)}>
            Cancelar
          </Button>
          <Button
            data-testid="submit-button"
            color="primary"
            type="submit"
            disabled={submitting}
            onClick={handleSubmit(save)}
          >
            {submitting && <Spinner size="sm" className="mr-2" />}
            Sí, pagar
          </Button>
        </ModalFooter>
      </Modal>
    </>
  );

  return (
    <>
      <PageHeader
        title="Emisión de pago de servicio"
        titleTag="h2"
        description={"Emite tu pago."}
        className="mb-3"
        col={{ lg: 9 }}
      >
        <SupportLink />
      </PageHeader>
      <Card
        data-testid="form"
        tag={Form}
        className="bg-transparent shadow-none"
        onSubmit={handleSubmit(save)}
      >
        <PreloadState
          loading={submitting}
          message={"Emitiendo pago por favor espere..."}
        >
          {renderForm()}
        </PreloadState>
      </Card>
    </>
  );
};

export default ManagerServicePayment;
